import React from 'react'

interface packet {
    title: string;
    data: string;
}
const Packet = ({title, data}: packet) => {
    return (
    <section className="card">
    <h3>{title}</h3>
    <p>{data}</p>
    </section>
    )
}

export default Packet
